import { Maybe } from 'maybeasy';
import { TProps } from '../../../Translations';

export const TOAST_DURATION_MS = 6000;

export interface ToastMessage {
  id: number;
  message: TProps;
  undo: Maybe<() => void>;
}

interface Hidden {
  kind: 'hidden';
}

interface Showing {
  kind: 'showing';
  toast: ToastMessage;
}

export type State = Hidden | Showing;

export const hidden = (): Hidden => ({ kind: 'hidden' });

export const showing = (toast: ToastMessage): Showing => ({ kind: 'showing', toast });
